/** Connected Fleet UX helpers — display only; never mutate PMV authority. */

export function connectivityTagColor(band: string | null | undefined): string {
  switch (band) {
    case 'ONLINE':
      return 'success';
    case 'DELAYED':
      return 'warning';
    case 'OFFLINE':
      return 'default';
    case 'UNKNOWN':
      return 'default';
    default:
      return 'default';
  }
}

/** Policy labels: Live / Delayed / Offline / Unknown — never "LIVE" for stale. */
export function connectivityLabel(band: string | null | undefined): string {
  switch (band) {
    case 'ONLINE':
      return 'Live';
    case 'DELAYED':
      return 'Delayed';
    case 'OFFLINE':
      return 'Offline';
    case 'UNKNOWN':
      return 'Unknown';
    default:
      return band ? band.charAt(0) + band.slice(1).toLowerCase() : 'Not connected';
  }
}

export function formatLastSeen(iso: string | null | undefined): string {
  if (!iso) return 'Never';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '—';
  const ageMs = Date.now() - t;
  const mins = Math.floor(ageMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  const d = new Date(iso);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

/**
 * Freshness copy per LIVE-STATE-POLICY.
 * Never label DELAYED/OFFLINE as Live.
 */
export function freshnessBadge(
  band: string | null | undefined,
  lastSeenIso?: string | null
): { label: string; live: boolean } {
  const age = formatLastSeen(lastSeenIso);
  if (band === 'ONLINE') return { label: `Live — updated ${age}`, live: true };
  if (band === 'DELAYED') return { label: `Delayed — last data ${age}`, live: false };
  if (band === 'OFFLINE') return { label: `Offline — last data ${age}`, live: false };
  if (!band || band === 'UNKNOWN') return { label: 'Unknown — no telemetry received', live: false };
  return { label: connectivityLabel(band), live: false };
}
